import React,{useState, useEffect} from 'react'
import Image from 'next/image'
import Link from 'next/link'
import StartaProject from '@/components/StartaProject'
import { getAllPostsForHome, getAllCategories, getPostsPerPage  } from '../../lib/post';

import { getSeoData  } from '../../lib/seo';
import { GetStaticProps } from 'next'
import Head from 'next/head'
import BlogList from '@/components/blogs/BlogList';
import { useRouter } from 'next/router';
import { IoSearch } from "react-icons/io5";
import { IoClose } from "react-icons/io5";
import SEO from '@/components/SEO'
interface PostCategory {
  name: string;
  slug: string;
}

interface Post {
  title: string;
  categories: {
    nodes: PostCategory[];
  };
}

interface BlogsPageProps {
  allPosts: {
    nodes: Post[];
  };
  preview: boolean;
  initialSeo:any;
  ppp:any
}

function Blogs({ allPosts, preview, initialSeo, ppp }:BlogsPageProps) {
    const [isOpen, setIsOpen] = useState(false);
  
    // blogs pagination and all other functionality start
    const [postsToShow, setPostsToShow] = useState(ppp || 12); // Initial number of posts to show
    const [posts, setPosts] = useState<Post[]>([]);
    const [categories, setCategories] = useState<PostCategory[]>([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {

      // featch all post
      const fetchPosts = async () => {
        const fetchedPosts = await getAllPostsForHome(false);
        setPosts(fetchedPosts?.nodes || []);
        setLoading(true)
      };
      fetchPosts();

      // fetch all categories
      const fetchCategories = async () => {
        const fetchedCategories = await getAllCategories();
        setCategories(fetchedCategories);
      };
      fetchCategories();
    }, []);
  
      // Function to handle the click event for loading more posts
      const handleLoadMore = () => {
        setPostsToShow((prev:any) => prev + 12); // Increase the number of posts to show by 12
        
      };


      const [searchTerm, setSearchTerm] = useState('');
      const [currentPage, setCurrentPage] = useState(1); 

      const toggleSearch = () => {
        setIsOpen((prevState) => !prevState);
        // Reset search term and clear input value when closing the search
        if (!isOpen) {
          setSearchTerm('');
          const inputElement = document.querySelector('input[type="search"]');
          if (inputElement instanceof HTMLInputElement) {
            inputElement.value = ''; // Clear the input value
          }
        }
      };
    
      const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value.toLowerCase());
        setCurrentPage(1);
      };
    
      const filteredPosts = posts.filter((post: Post) => {
        if (searchTerm) {
          const postTitle = post.title.toLowerCase() || '';
          return postTitle.includes(searchTerm);
        }
        return true;
      });
    
      const postsToDisplay = isOpen ? filteredPosts.slice(0, postsToShow) : posts.slice(0, postsToShow);
      const hasMorePosts = postsToDisplay.length < filteredPosts.length;
  return (
   <div className='blogs_page header_gap'>
  <SEO initialSeo={initialSeo}/>
    <section className='sp_bottom'>
      <div className="container">
        <div className="page_title">
            <h1 className='f54' data-aos="fade" data-aos-delay="100">Blogs</h1>
        </div>
        <div className="blog_head">
            <ul className="blog_category">
              {categories.map((category) => (
                <li key={category.slug}  data-aos="fade-right" data-aos-delay="100">
                  <Link href={`/category/${category?.slug}`}> {category?.name}</Link>
                </li>
              ))}
            </ul>
            <div className={`search-toggle ${isOpen ? 'opened' : 'closed'}`} >
              <button className="search-icon" onClick={toggleSearch} aria-label="search">
                  {
                    isOpen ? <IoClose /> : <IoSearch />
                  }
                 
              </button>
              <div className={`search-container ${isOpen ? 'opened' : ''}`}>
                <form>
                  <input type="search" onChange={handleSearchChange} placeholder="Search..." />
                </form>
              </div>
            </div>
          </div>
        <div className="listingBoxWrap">
          <div className="row tb_space">
              <BlogList  posts={postsToDisplay}/>
          </div>
          {hasMorePosts && (
              <div className="load_more" data-aos="fade-down" data-aos-delay="100">
                <button onClick={handleLoadMore} className='cmn_btn'><span>Load more articles</span></button>
              </div>
            )}
            {/* {!hasMorePosts && postsToDisplay.length > 0 && <p>No more articles to load.</p>} */}
            
            {loading && (
                <>
                  {!posts || postsToDisplay.length === 0 && <p className='text-center mt-5'>No results found.</p>}
                </>
            ) }
        </div>
      </div>
    </section>
    <StartaProject/>
   </div>
  )
}

export default Blogs

export const getStaticProps: GetStaticProps = async ({ preview = false }) => {
  const allPosts = await getAllPostsForHome(preview)
  const ppp = await getPostsPerPage()
  const initialSeo = await getSeoData("blogs")
  return {
      props: { allPosts, preview, ppp, initialSeo },
      revalidate: 10,
  }
}
